import * as React from "react";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import { SnapshotCollectionsOutcomesExport } from "./exportOutcomes";
import { SnapshotCollectionsOutcomesList } from "./list";
import { SnapshotCollectionsOutcomesSearch } from "./search";
import { CommonTabs } from "@/components/app/tabs";
import { CommonTabsItem } from "@/components/app/tabs/types";
import { Database, MessageSquare, Search } from "lucide-react";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { SnapshotCollectionsOutcomesQA } from "./qa";
import { useSearchParams } from "react-router";

interface Props {
  selectedCollection: SnapshotCollection;
}

const tabs: CommonTabsItem[] = [
  {
    name: "data",
    label: "Data",
    icon: <Database />,
  },
  {
    name: "search",
    label: "Search",
    icon: <Search />,
  },
  {
    name: "qa",
    label: "Q&A",
    icon: <MessageSquare />,
  },
];

export const SnapshotCollectionsOutcomes: React.FC<Props> = ({ selectedCollection }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChangeTab = (value: string) => {
    setSearchParams(prev => {
      prev.set("tab", value);
      return prev;
    });
  };

  return (
    <Tabs defaultValue={searchParams.get("tab") || "data"} onValueChange={handleChangeTab} className="mt-8 w-full">
      <div className="mt-8">
        <div className="flex items-end">
          {selectedCollection && <SnapshotCollectionsOutcomesExport snapshotCollection={selectedCollection} />}
          <div className="flex">
            <CommonTabs tabs={tabs} />
          </div>
        </div>
        <div className="mt-4 flow-root">
          <TabsContent value="data">
            <SnapshotCollectionsOutcomesList selectedCollection={selectedCollection} />
          </TabsContent>
          <TabsContent value="search">
            <SnapshotCollectionsOutcomesSearch selectedCollection={selectedCollection} />
          </TabsContent>
          <TabsContent value="qa">
            <SnapshotCollectionsOutcomesQA selectedCollection={selectedCollection} />
          </TabsContent>
        </div>
      </div>
    </Tabs>
  );
};
